import React from "react";
import { useParams } from "react-router-dom";
import books from "./books"; // Import your book data
import { Card } from "react-bootstrap";
import Header4 from "../components/Header4";
import Footer2 from "../components/Footer2";

const BookDetailPage = () => {
  const { id } = useParams();
  const book = books[parseInt(id)]; // Retrieve the book based on the ID

  if (!book) return <h2>Book not found!</h2>;

  return (
    <>
      <div className="" style={{ height: "100vh" }}>
        <Header4 />
        <div className="mt-5">
          <Card className="border-0  " style={{ width: "" }}>
            <div className="mx-auto d-lg-flex gap-3">
              <Card.Img
                className="imgsize157"
                variant="top"
                src={book.image}
                style={{ width: "280px", height: "380px" }}
              />

              <Card.Body className="p-0 mt-2">
                <Card.Title
                  className=" w-100 fw-bold ftztitle "
                  style={{
                    color: "#6D6D6D",
                    fontSize: "36px",

                    lineHeight:
                      book.title[0] === "Before the coffee" ? "20px" : "40px", // Conditional line height
                  }}
                >
                  {book.title[0]} <br /> {book.title[1]}
                </Card.Title>

                <Card.Text
                  className=" ftzgern fw-bold fs-4 mt-3"
                  style={{
                    color: "#000000",

                    lineHeight: "40px",
                  }}
                >
                  <strong>Genre: </strong>
                  {book.genre}
                </Card.Text>

                <Card.Title
                  className=" ftzgern fw-bold fs-4 mt-3"
                  style={{
                    color: "#000000",

                    lineHeight: "40px",
                  }}
                >
                  <strong>Age Group: </strong>
                  {book.ageGroup}
                </Card.Title>

                <Card.Text
                  className=" w-100 ftzgern fw-bold fs-4 mt-4"
                  style={{
                    color: "#383838",

                    lineHeight: "40px",
                    maxWidth: "213px",
                  }}
                >
                  <strong>Event Date: </strong>
                  {book.eventDate}
                </Card.Text>

                <Card.Title
                  className=" ftzgern fw600 fs-4 mt-4"
                  style={{
                    color: "#C9321F",

                    lineHeight: "30px",
                  }}
                >
                  <strong>Event Type: </strong>
                  {book.eventType}
                </Card.Title>
              </Card.Body>
            </div>
          </Card>
        </div>
        <div style={{ marginTop: "100px" }}>
          <Footer2 />
        </div>
      </div>
    </>
  );
};

export default BookDetailPage;
